<!--
 * @Author: your name
 * @Date: 2022-04-25 16:24:19
 * @LastEditTime: 2022-04-26 10:32:34
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \zhy\src\components\security\security.vue
-->
<template>
  <div class='security'>
      <div>
        <div class="title1">
            <div class="title-text1">人员管理</div>
        </div>
        <div class="pl_tit">
            <p>离场人数：<span>398</span></p>
            <p>离场人数：<span>398</span></p>
            <p>入场人数：<span>985</span></p>
        </div>
        <div class="pl_nav">
            <p>序号</p>
            <p>工号</p>
            <p>姓名</p>
            <p>是否在岗</p>
        </div>
        <ul class="pl_list">
            <li v-for="item,index in plList" :key="index" :style="{background:index%2==0?'':'rgba(152, 254, 249,0.302)',backgroundClip: 'content-box'}"> 
                <p><span></span> {{item.id}}</p>
                <p>{{item.number}}</p>
                <p>{{item.name}}</p>
                <p>{{item.status}}</p>
            </li>
        </ul>
      </div>
      <div>
        <div class="title1">
            <div class="title-text1">安防设施</div>
        </div>
        <div class="af_nav">
            <p>设施编号</p>
            <p>设施名称</p>
            <p>设备位置</p>
            <p>使用情况</p>
        </div>
        <ul class="af_cot">
            <li v-for="item,index in afList" :key="index">
                <p><span></span>{{item.id}}</p>
                <p>{{item.name}}</p>
                <p>{{item.weiz}}</p>
                <p>{{item.status}}</p>
            </li>
        </ul>
      </div>
      <div>
          <div class="title1">
            <div class="title-text1">监控管理</div>
          </div>
          <div class="jk_nav">
              <p>设备编号</p>
              <p>设备位置</p>
          </div>
          <ul class="jk_cot">
              <li v-for="item,index in jkList" :key="index"> 
                  <p>{{item.id}}</p>
                  <p>{{item.weiz}}</p>
              </li>
          </ul>
      </div>
      <div>
          <div class="title1">
            <div class="title-text1">重点监控</div>
          </div>
          <div class="content">
          <div class="zd_text">
             <div class="zd_cont">
                <video ref="video3" src="../assets/video/1.mp4" muted loop autoplay></video>
          </div>
                <div>
                    <p>监控-01</p>
                    <p>{{nowDate}} {{nowTime}} {{nowWeek}} </p>
                </div>
                
          </div>
          <div class="zd_text">
              <div class="zd_cont">
                <video ref="video3" src="../assets/video/3.mp4" muted loop autoplay></video>
          </div>
                <div>
                    <p>监控-02</p>
                    <p>{{nowDate}} {{nowTime}} {{nowWeek}} </p>
                </div>
                
          </div>
          </div>
      </div>
      
  </div>
</template>
<script>
export default {
  name: "Security",
  data () {
   return {
        nowTime: "", //当前时间，时，分，秒 23:23:23
      nowDate: "", //当前日期
      nowWeek: "", //当前星期
       plList:[{
           id:'0001',
           number:'654001',
           name:"王XX",
           status:"在线"
       },{
           id:'0001',
           number:'654001',
           name:"王XX",
           status:"在线"
       },{
           id:'0001',
           number:'654001',
           name:"王XX",
           status:"在线"
       },{
           id:'0001',
           number:'654001',
           name:"王XX",
           status:"在线"
       },{
           id:'0001',
           number:'654001',
           name:"王XX",
           status:"在线"
       }],
       afList:[{
           id:'Ak02316',
           name:"消防栓",
           weiz:'A区一楼楼梯处',
           status:"可正常使用"
       },{
           id:'Ak02316',
           name:"消防栓",
           weiz:'A区一楼楼梯处',
           status:"可正常使用"
       },{
           id:'Ak02316',
           name:"消防栓",
           weiz:'A区一楼楼梯处',
           status:"可正常使用"
       },{
           id:'Ak02316',
           name:"消防栓",
           weiz:'A区一楼楼梯处',
           status:"可正常使用"
       }],
       jkList:[{
           id:'Ak02316',
           weiz:"A区一楼楼梯处"
       },{
           id:'Ak02316',
           weiz:"A区一楼楼梯处"
       },{
           id:'Ak02316',
           weiz:"A区一楼楼梯处"
       },{
           id:'Ak02316',
           weiz:"A区一楼楼梯处"
       }]
   }
  },
   components:{},
   methods:{
       //时间格式转换
    covert(arg) {
      return arg < 10 ? "0" + arg : arg;
    },
    getTime() {
      let date = new Date(); //获取当前日期信息
      let year = date.getFullYear(); //获取当前年
      let month = date.getMonth() + 1; //获取当前月
      let day = date.getDate(); //获取当前天
      let week = date.getDay(); //获取星期
      let hour = date.getHours(); //获取当前小时
      let minutes = date.getMinutes(); //获取当前分
      let seconds = date.getSeconds(); //获取当前小时
      
      this.nowDate = year + "-" + this.covert(month) + "-" + this.covert(day);
this.nowTime =
        this.covert(hour) +
        ":" +
        this.covert(minutes) +
        ":" +
        this.covert(seconds);

      const weeks = new Array(
       "周日",
        "周一",
        "周二",
        "周三",
        "周四",
        "周五",
        "周六"
      );
      this.nowWeek = weeks[week];
    },
   },
   watch:{},
   created() {
   this.getTime();
    setInterval(this.getTime, 500);
   },
   mounted() {
   
  }
}
</script>
<style scoped>
*{margin: 0;padding: 0;}
li{list-style: none;}
.security{
 width: 94VW;
 height: 18vh;
 position: fixed;
 display: flex;
 left: 50%;
 bottom: 5vh;
 transform: translateX(-50%);
 justify-content: space-between;
}
.security>div{
    position: relative;
}
.security>div:nth-of-type(1){
    width:25.5%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.security>div:nth-of-type(2){
    width:30%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.security>div:nth-of-type(3){
    width:14.5% ;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.security>div:nth-of-type(4){
    width:24.5% ;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.title1{
    width: 244px;
    height: 37px;
    background: url('../assets/securityl/title.png') no-repeat center center/100% 100%;
    position: absolute;
    left: 0;
    top: 0;
    transform: translateY(-110%);
}
.title-text1{
    height: 32px;
    width: 82.5%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    font-size: 22px;
}
.pl_tit{
    height: 15%;
    width: 100%;
    background: url('../assets/securityl/pl_tit.png') no-repeat center center/100% 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    color: white;
}
.pl_tit p{
    margin: 0;
}
.pl_tit p span{
    color: #98fef9;
}

.pl_nav{
    height:12.5%;
    /* margin: 2% 0; */
    display: flex;
    font-size: 12px;
    color: rgb(255, 255, 255);
    font-family: "SourceHanSansCNVF";
    justify-content: space-around;
    align-items: center;
    background: url('../assets/securityl/pl_nav.png') no-repeat center center/100% 100%;
}
.pl_nav>div{
    width: 22%;
}
.pl_list{
    width: 100%;
    height: 68.5%;
    overflow: auto;
}
.pl_list::-webkit-scrollbar{
    width: 5px;
    height: 5px;
    background: transparent;
}

.content{
     width: 100%;
    margin-top: 1vh;
    height: 17vh;
    display: flex;
}

.pl_list::-webkit-scrollbar-thumb{
    background-color: rgb(152, 254, 249);
    border-radius: 10px;
}

.pl_list>li{
    height: 25%;
    padding: 1% 10px 1% 0;
    
    display: flex;
    align-items: center;
    box-sizing: border-box;
}

.pl_list>li>p{
  width: 25%;
  text-align: center;
  font-size: 12px;
  font-family: "SourceHanSansCNVF";
  color: rgb(255, 255, 255);
  display: flex;
  align-items: center;
  justify-content: center;
}
.pl_list>li>p>span{
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 6px;
    background: #98fef9;
    margin-right: 10px;
}
.af_nav{
    font-size: 12px;
    font-family: "SourceHanSansCNVF";
    color: rgb(255, 255, 255);
    height: 15.7%;
    width: 100%;
    background: url('../assets/securityl/pl_nav.png') no-repeat center center/100% 100%;
    display: flex;
    align-items: center;
    justify-content: space-around;
}
.af_cot{
    width: 100%;
    height: 80%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.af_cot>li{
    height: 25%;
    background: url('../assets/securityl/aflibg.png') no-repeat  bottom center/100% auto;
    display: flex;
    align-items: center;
}
.af_cot>li>P{
    width: 25%;
    font-size: 12px;
    font-family: "SourceHanSansCNVF";
    color: rgb(255, 255, 255);
    display: flex;
    align-items: center;
    justify-content: center;
}
.af_cot>li>P span{
    width: 5px;
    height: 5px;
    background: #98fef9;
    display: inline-block;
    margin-right: 5px;
    border-radius: 5px;
}
.jk_nav{
    height: 15.7%;
    width: 100%;
    font-size: 12px;
    font-family: "SourceHanSansCNVF";
    color: rgb(255, 255, 255);
    background: url('../assets/securityl/pl_nav.png') no-repeat center center/100% 100%;
    display: flex;
    align-items: center;
    justify-content: space-around;
}
.jk_cot{
    width: 100%;
    height: 80%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.jk_cot>li{
    height: 23%;
    font-size: 12px;
    font-family: "SourceHanSansCNVF";
    color: rgb(255, 255, 255);
    display: flex;
    align-items: center;
    background: url('../assets/securityl/jklsbg.png') no-repeat bottom center/100% auto;
}
.jk_cot>li:not(:nth-of-type(odd)){
    background: rgba(152, 254, 249,.3);
}
.jk_cot>li>P{
    width: 50%;
    text-align: center;
}
.zd_cont{
    width: 100%;
    height: 63%;
    display: flex;
    justify-content: space-between;
}
.zd_cont>video{
    width: 100%;
    height: 100%;
    /* background: url('../assets/securityl/video.png') no-repeat center center /100% 100%; */
}
.zd_text{
    justify-content: space-between;
    font-size: 12px;
    font-family: "SourceHanSansCNVF";
    color: rgb(255, 255, 255);
    margin-right: 30px;
}
/* .zd_text p{
    margin: 5px;
} */
</style>
